import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link } from "react-router-dom";
import "./breadcrumbs.scss";

const TwoBreadcrumb = ({ activeName }) => {
  return (
    <div role="presentation" className="breadcrumb">
      <Breadcrumbs aria-label="breadcrumb">
        <Link to="/" className="link">
          Home
        </Link>
        <div aria-current="page">{activeName}</div>
      </Breadcrumbs>
    </div>
  );
};
export default TwoBreadcrumb;
